import { useOutletContext } from 'react-router-dom';
import TitlesTable from '../../components/TitlesTable';
import DefaultLayoutV3 from '../../layout/DefaultLayoutV3';
import { WorkspaceOutletContext } from '../../types/workspaceTypes';

const Titles = () => {
  const { workspaceId } = useOutletContext<WorkspaceOutletContext>();

  return (
    <DefaultLayoutV3.Content>
      <div className="space-y-5 self-stretch">
        <h2>All Titles</h2>

        <TitlesTable workspaceId={workspaceId} />
      </div>
    </DefaultLayoutV3.Content>
  );
};

export default Titles;
